var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55556 11C8.00327 11 7.55556 11.4477 7.55556 12C7.55556 12.5523 8.00327 13 8.55556 13V11ZM17.4444 13C17.9967 13 18.4444 12.5523 18.4444 12C18.4444 11.4477 17.9967 11 17.4444 11V13ZM12 16.4444C12 16.9967 12.4477 17.4444 13 17.4444C13.5523 17.4444 14 16.9967 14 16.4444H12ZM14 7.55556C14 7.00327 13.5523 6.55556 13 6.55556C12.4477 6.55556 12 7.00327 12 7.55556H14ZM13 21C8.02944 21 4 16.9706 4 12H2C2 18.0751 6.92487 23 13 23V21ZM4 12C4 7.02944 8.02944 3 13 3V1C6.92487 1 2 5.92487 2 12H4ZM13 3C17.9706 3 22 7.02944 22 12H24C24 5.92487 19.0751 1 13 1V3ZM22 12C22 16.9706 17.9706 21 13 21V23C19.0751 23 24 18.0751 24 12H22ZM8.55556 13H17.4444V11H8.55556V13ZM14 16.4444V7.55556H12V16.4444H14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2096",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2096",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.abce4a8435efac17276d3d7b2581bceb.svg";
export { ForwardRef as ReactComponent };